import { create } from 'jsondiffpatch';

// Configured for the RoutineRunnerState shape: no array LCS / move
// detection (state has only fixed-position arrays — joint angles, IO ports,
// etc.), no diff-match-patch text diff (identifier-length strings only),
// no value cloning inside the delta (we don't mutate the inputs).
export const statePatchDiffer = create({
  arrays: { detectMove: false, includeValueOnMove: false },
  textDiff: { minLength: Infinity },
  cloneDiffValues: false,
});
